'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Issue = function Issue(_ref) {
  var size = _ref.size,
      color = _ref.color;
  return _react2.default.createElement(
    'svg',
    {
      width: size,
      height: size,
      viewBox: '0 0 52 52'
    },
    _react2.default.createElement('rect', {
      x: 0,
      y: 0,
      width: 52,
      height: 52,
      fill: color,
      rx: 6
    }),
    _react2.default.createElement(
      'g',
      { transform: 'translate(0, -5)' },
      _react2.default.createElement('path', {
        d: 'M49.787 12.207a.736.736 0 0 1-.728-.743c-.154-1.313-1.163-2.352-2.448-2.52a.736.736 0 0 1-.729-.743c0-.411.326-.744.729-.744 2.094.164 3.756 1.869 3.905 4.007 0 .41-.327.743-.729.743z',
        fill: '#FFF',
        fillRule: 'nonzero',
        opacity: '0.5'
      }),
      _react2.default.createElement('path', {
        d: 'M43.35 8.741H27.657a.737.737 0 0 1-.728-.745c0-.412.326-.746.728-.746H43.35c.402 0 .728.334.728.746a.737.737 0 0 1-.728.745zm6.654 15.557a.745.745 0 0 1-.745-.744v-9.346a.745.745 0 0 1 1.491 0v9.346c0 .411-.334.744-.746.744z',
        fill: '#FFF',
        fillRule: 'nonzero',
        opacity: '0.3'
      })
    ),
    _react2.default.createElement(
      'g',
      { transform: 'translate(-3, -3)' },
      _react2.default.createElement('path', {
        d: 'M28.665 13.385a4.058 4.058 0 0 1 4.058 4.058v13.11a4.058 4.058 0 0 1-8.116 0v-13.11a4.058 4.058 0 0 1 4.058-4.058zm0 23.723a4.058 4.058 0 1 1 0 8.115 4.058 4.058 0 0 1 0-8.115z',
        fill: '#FFF',
        fillRule: 'evenodd'
      })
    )
  );
};

Issue.propTypes = {
  color: _propTypes2.default.string,
  size: _propTypes2.default.number
};

Issue.defaultProps = {
  color: '#F1C40F',
  size: 52
};

exports.default = Issue;